<section class="page">
  <header class="page-header">
    <div>
      <h1>QA &amp; Test Plans</h1>
      <p>Manage test plans, cases, and execution runs per project.</p>
    </div>
    <button mat-flat-button color="primary" type="button" (click)="showCreate = !showCreate">
      <mat-icon>add</mat-icon> New test plan
    </button>
  </header>

  @if (error()) { <div class="error">{{ error() }}</div> }

  <div class="toolbar">
    <mat-form-field appearance="outline">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="filterProjectId" (ngModelChange)="onFilterChange()">
        <mat-option value="">All projects</mat-option>
        @for (p of projects(); track p.id) {
          <mat-option [value]="p.id">{{ p.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-stroked-button type="button" (click)="loadPlans()"><mat-icon>refresh</mat-icon> Refresh</button>
  </div>

  @if (showCreate) {
    <mat-card class="create-card">
      <mat-card-content>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Project *</mat-label>
            <mat-select [(ngModel)]="planProjectId">
              @for (p of projects(); track p.id) {
                <mat-option [value]="p.id">{{ p.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="grow">
            <mat-label>Plan name *</mat-label>
            <input matInput [(ngModel)]="planName" maxlength="200" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Version label</mat-label>
            <input matInput [(ngModel)]="planVersion" />
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="full">
          <mat-label>Description</mat-label>
          <textarea matInput rows="2" [(ngModel)]="planDescription"></textarea>
        </mat-form-field>
        <button mat-flat-button color="primary" [disabled]="saving() || !planProjectId || !planName.trim()" (click)="createPlan()">
          {{ saving() ? 'Creating…' : 'Create plan' }}
        </button>
      </mat-card-content>
    </mat-card>
  }

  @if (loading()) {
    <div class="loading"><mat-spinner diameter="36"></mat-spinner></div>
  } @else {
    <table mat-table [dataSource]="plans()" class="full">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let p">
          <button mat-button type="button" (click)="openPlan(p.id)">{{ p.name }}</button>
        </td>
      </ng-container>
      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef>Version</th>
        <td mat-cell *matCellDef="let p">{{ p.version || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef>Active</th>
        <td mat-cell *matCellDef="let p">{{ p.isActive ? 'Yes' : 'No' }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let p">
          <button mat-icon-button type="button" (click)="openPlan(p.id)"><mat-icon>open_in_new</mat-icon></button>
          <button mat-icon-button color="warn" type="button" (click)="deletePlan(p)"><mat-icon>delete</mat-icon></button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
    @if (!plans().length) { <p class="muted">No test plans yet.</p> }
  }
</section>
